<template>
    <el-card shadow="hover">
        <label slot="header">快速切换栏</label>
        依赖store.js中的JMenu模块
        <el-divider content-position="left">j-quick-tab</el-divider>
        <j-quick-tab />
    </el-card>
</template>

<script>
    import JQuickTab from "./JQuickTab";
    export default {
        components: {
            JQuickTab
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
